module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Leistungen_Layer.fc496346.jpg";